import script from "./area-project-view.vue?vue&type=script&lang=js&setup=true"
export * from "./area-project-view.vue?vue&type=script&lang=js&setup=true"

import "./area-project-view.vue?vue&type=style&index=0&id=48bbb2f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48bbb2f5"]])

export default __exports__